import React, { Component } from 'react';

import compose from '../../../lib/utils/compose';
import { withTPA } from '../../context/tpa';
import { withSettings } from '../../context/settings';
import { withExperiments } from '../../context/experiments';

class DebugPanel extends Component<{
  tpa: any;
  settings: any;
  experiments: any;
}> {
  state = {
    isVisible: false,
  };

  onKeyPress = (e) => {
    if (e.code === 'KeyD' && e.altKey) {
      this.setState({
        isVisible: true,
      });
    }
  };

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyPress);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyPress);
  }

  render() {
    const { tpa, settings, experiments } = this.props;
    const { isVisible } = this.state;

    if (!isVisible) {
      return null;
    }

    return (
      <div
        style={{
          width: '100%',
          maxWidth: '960px',
          margin: '0 auto',
        }}
      >
        <details>
          <summary>TPA</summary>
          <pre>{JSON.stringify(tpa, null, 2)}</pre>
        </details>
        <details>
          <summary>Settings</summary>
          <pre>{JSON.stringify(settings, null, 2)}</pre>
        </details>
        <details>
          <summary>Experiments</summary>
          <pre>{JSON.stringify(experiments, null, 2)}</pre>
        </details>
      </div>
    );
  }
}

export default compose(withTPA, withSettings, withExperiments)(DebugPanel);
